import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import './UpgradePrompt.css';

const UpgradePrompt: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  // Only show for FREE plan users
  const isFreeUser = user?.apiKeys?.some((key: any) => key.plan?.toLowerCase() === 'free');
  
  if (!user || !isFreeUser) {
    return null;
  }

  return (
    <div className="upgrade-prompt">
      <div className="upgrade-content">
        <span className="upgrade-icon">🚀</span>
        <div className="upgrade-text">
          <h4>Remove Ads & Get More Features</h4>
          <p>Upgrade to Pro for ad-free experience + higher limits</p>
        </div>
        <button 
          className="upgrade-button"
          onClick={() => navigate('/pricing')}
        >
          Upgrade Now
        </button>
      </div>
    </div>
  );
};

export default UpgradePrompt;